import { render, staticRenderFns } from "./ButtonEditBed.vue?vue&type=template&id=cee85250&"
import script from "./ButtonEditBed.vue?vue&type=script&lang=js&"
export * from "./ButtonEditBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports